import { SHOW_LOADER, REMOVE_LOADER } from '../actionTypes/LoadingActionTypes';

const showLoader = () => ({
    type: SHOW_LOADER,
});

const removeLoader = () => ({
    type: REMOVE_LOADER,
});

export default {
    showLoader,
    removeLoader,
};
